import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    title: {
      fontWeight: 600,
      color: palette.common.black,
      margin: 0
    },
    listdiv: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      fontSize: '0.75rem'
    },
    text: {
      color: palette.text.primary,
      fontSize: '0.875rem',
      fontWeight: 500
    },
    desc: {
      fontSize: '0.875rem',
      margin: 0
    },
    bold: {
      fontWeight: 600
    },
    block: {
      background: palette.background.underBox,
      padding: '10px',
      borderRadius: palette.borderRadius.default
    },
    withImg: {
      display: 'flex',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
